var _dec, _class;
import { useCurrencyStore, useFacetsStore, useSearchStore, useSearchWizardStore } from '#imports';
import { Component, Vue } from 'vue-property-decorator';
var BasicLayout = (_dec = Component({
  setup() {
    var searchStore = useSearchStore(usePinia());
    var searchWizardStore = useSearchWizardStore(usePinia());
    // setup facet store so facets available to all components
    var facetsStore = useFacetsStore();
    // setup to fetch currencies ASAP
    var currencyStore = useCurrencyStore();
    return {
      currencyStore,
      facetsStore,
      searchStore,
      searchWizardStore
    };
  }
}), _dec(_class = class BasicLayout extends Vue {}) || _class);
export { BasicLayout as default };